var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.71429C15 0.771429 14.2286 0 13.2857 0H10.7143V1.71429H13.2857V3.98571L10.3029 7.71429H7.28573V3.42857H3.85716C1.96287 3.42857 0.428589 4.96286 0.428589 6.85714V9.42857H2.14287C2.14287 10.8514 3.29145 12 4.7143 12C6.13716 12 7.28573 10.8514 7.28573 9.42857H11.1257L15 4.58571V1.71429ZM2.14287 7.71429V6.85714C2.14287 5.91429 2.9143 5.14286 3.85716 5.14286H5.57145V7.71429H2.14287ZM4.7143 10.2857C4.24287 10.2857 3.85716 9.9 3.85716 9.42857H5.57145C5.57145 9.9 5.18573 10.2857 4.7143 10.2857Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.857117H7.28571V2.5714H3V0.857117ZM15 6.85712C13.5771 6.85712 12.4286 8.00569 12.4286 9.42854C12.4286 10.8514 13.5771 12 15 12C16.4229 12 17.5714 10.8514 17.5714 9.42854C17.5714 8.00569 16.4229 6.85712 15 6.85712ZM15 10.2857C14.5286 10.2857 14.1429 9.89997 14.1429 9.42854C14.1429 8.95712 14.5286 8.5714 15 8.5714C15.4714 8.5714 15.8571 8.95712 15.8571 9.42854C15.8571 9.89997 15.4714 10.2857 15 10.2857Z",
    fill: "#F7F7F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/moto.493951a7a40ed4569ff2d237b04e5652.svg";
export { ForwardRef as ReactComponent };